<template>
  <session class="page-login-comp" v-if="show">
    <div class="bg" @click="closeLogin" />
    <div class="login-comp-wrap">
      <div class="login-comp-l">
        <div class="login-form-block" v-if="step == 1">
          <div class="blocktitle">
            <span class="main" :class="{ ffen: getLocalLangCode() != 'zh' }">{{LOCAL('login_loginType')}}</span>
            <span class="sub" v-html="Utils.presetHtmlText(LOCAL('login_loginType_desc'))" />
          </div>
          <div class="blockcate">
            <div class="item" :class="{ active: curEntrance?.id == item?.id }" v-for="(item, index) in entrancesList" :key="index" @click="selectEntrance(item)">
              <div class="line" />
              <div class="item-content">
                <div class="iteml">
                  <Icon :name="item?.icon" />
                  <div class="content">
                    <span class="title" :class="{ ffen: getLocalLangCode() != 'zh' }">{{item?.title}}</span>
                    <span class="desc" :class="{ ffen: getLocalLangCode() != 'zh' }">{{item?.desc}}</span>
                  </div>
                </div>
                <div class="itemr">
                  <Icon name="checkmore" size="48" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="login-form-block" v-if="step == 2">
          <div class="blocktitle">
            <div class="backwrap" @click="step = 1"><Icon name="back" /><span>{{LOCAL('back')}}</span></div>
            <span class="main" :class="{ ffen: getLocalLangCode() != 'zh' }">{{curEntrance?.title}}</span>
          </div>
          <div class="blockform-wrap">
            <div class="item" :class="{ 'item-err': showAccountError }">
              <Icon name="account" />
              <div class="input-wrap"><input v-model="accountValue" :placeholder="`${LOCAL('account')}/${LOCAL('email')}`" /></div>
              <div class="errortip" v-if="showAccountError">{{ LOCAL('login_error_account') }}</div>
            </div>
            <div class="item" :class="{ 'item-err': showPasswordError }">
              <Icon name="password" />
              <div class="input-wrap">
                <input v-model="passwordValue" autocomplete="new-password" :type="showPassword ? 'text' : 'password'" :placeholder="LOCAL('password')" type="password" @input="e => startInputPassword(e.target.value)"/>
                <Icon v-if='startInput' :name="showPassword ? 'pass_0' : 'pass_1'" style="cursor: pointer;" @click="showPassword = !showPassword" />
              </div>
              <div class="errortip" v-if="showPasswordError">{{ LOCAL('login_error_password') }}</div>
            </div>
            <div class="desclink" style="margin-top: -6px;">
              <span :class="{ fmin: getLocalLangCode() === 'jp' }" v-html="LOCAL('login_forget_password_tip')" /><span class="forget-password" :class="{ fmin: getLocalLangCode() === 'jp' }" @click="toTagetPage2('/resetpassword')" v-html="LOCAL('login_forget_password_find')" />
            </div>
            <div class="submitbtn" @click="submitHandle"><span :class="{ ffen: getLocalLangCode() != 'zh' }">{{LOCAL('login')}}</span></div>
            <div class="desclink" style="margin-top: 24px; justify-content: center;">
              <span :class="{ fmin: getLocalLangCode() === 'jp' }" v-html="LOCAL('login_noaccount_tip')" /><span class="register-now" :class="{ fmin: getLocalLangCode() === 'jp' }" @click="toTagetPage('/register',curEntrance?.id)" v-html="LOCAL('login_regsiter_now')" />
            </div>
          </div>
        </div>
      </div>
      <div class="login-comp-r">
        <img class="logo" src="@/assets/images/logo-en.svg" v-if="!getLocalLangCode() || getLocalLangCode() == 'en'" />
        <img class="logo" src="@/assets/images/logo.svg" v-if="getLocalLangCode() == 'zh'" />
        <img class="logo" src="@/assets/images/logo-jp.svg" v-if="getLocalLangCode() == 'jp'" />
        <img class="logo" src="@/assets/images/logo-kr.svg" v-if="getLocalLangCode() == 'kr'" />
        <div class="close-wrap" @click="closeLogin"><icon name="close" /></div>
      </div>
    </div>
  </session>
</template>

<script setup>
  import { ref, onMounted, watch } from 'vue';
  import * as Utils from '@/assets/utils';
  import Icon from '@/components/icon/index.vue';
  import EventBus from '@/assets/eventbus';
  import { LOCAL, getLocalLangCode } from '@/assets/lang';
  import router from '@/router';
  import { useRoute } from 'vue-router'

  // 流出步骤
  const step = ref(1);  // 1 - 第一步；2 - 第二步

  const show = ref(false);
  onMounted(() => {
    EventBus.on('login_dialog_key', (data = null) => {
      show.value = data?.flag || false
      if(data?.type === 'person'){
        curEntrance.value  = entrancesList.value[0]
        step.value = 2;
      } else if(data?.type === 'unit'){
        curEntrance.value  = entrancesList.value[1]
        step.value = 2;
      } else {
        step.value = 1;
      }
    });
  });

  /**
   * 第一步
   */
  // 入口列表
  const entrancesList = ref([]);
  const curEntrance = ref(null);
  const init = () => {
    entrancesList.value = [
      { title: LOCAL('login_loginType_1_title'), desc: LOCAL('login_loginType_1_desc'), icon: 'person', id: 'person' },
      { title: LOCAL('login_loginType_2_title'), desc: LOCAL('login_loginType_2_desc'), icon: 'enterprise', id: 'enterprise' },
      { title: LOCAL('login_loginType_3_title'), desc: LOCAL('login_loginType_3_desc'), icon: 'agent', id: 'agent' },
    ]
  }
  onMounted(() => {
    init()
  });

  // 选择入口
  const selectEntrance = item => {
    curEntrance.value = item;
    step.value = 2;
  }

  /**
   * 第二步
   */
  const showPassword = ref(false);

  const accountValue = ref('');
  const passwordValue = ref('');
  const showAccountError = ref(false);
  const showPasswordError = ref(false);
  const startInput = ref(false)

const startInputPassword = (e) => {
  if(e.length > 0){
  startInput.value = true

  } else {
  startInput.value = false}
}

  // 关闭
  const backHandle = () => {
    step.value = 1;
    accountValue.value = '';
    passwordValue.value = '';
    showAccountError.value = false;
    showPasswordError.value = false;
  }

  // 提交
  const submitHandle = () => {
    console.log('accountValue.value', accountValue.value, 'passwordValue.value', passwordValue.value);
    showAccountError.value = false;
    showPasswordError.value = false;

    if(!accountValue.value) {
      showAccountError.value = true;
      return;
    }
    if(!passwordValue.value) {
      showPasswordError.value = true;
      return;
    }
  }

  const rt = useRoute();

  const toTagetPage = (path, para) => {
    Utils.loginDialogToggle(false)
    curEntrance.value = null
    if(rt.path === '/register') {
      router.replace(
      { 
        path: '/register', 
        query: {
          plan: para
        }  
      });
    } else {
      router.push(
      { 
        path: path || '/', 
        query: { 
          plan: para 
        }  
      });
    }
    
  }

  const toTagetPage2 = (path) => {
    Utils.loginDialogToggle(false)
    Utils.resetPasswordon(false)
    curEntrance.value = null
    if(rt.path === '/resetpassword') {
      router.replace(
      { 
        path: '/resetpassword', 
      });
    } else {
      router.push(
      { 
        path: path || '/'
      });
    }
    
  }

  const closeLogin = () => {
    Utils.loginDialogToggle(false)
    curEntrance.value = null
  }

</script>

<style scoped lang="less">
  @import "index.less";
</style>
